// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".draggable__icon[data-v-50cd8041]{cursor:move}.list-group-item[data-v-50cd8041]{position:relative;display:block;padding:.5rem 1rem;margin-bottom:-1px;background-color:#fff;border:1px solid rgba(7,9,25,.125)}", ""]);
// Exports
module.exports = exports;
